<template>
  <div>
    <a-upload
        :headers="headers"
        :accept="accept"
        :action="url||action"
        list-type="picture-card"
        :multiple="num>1"
        :showUploadList="false"
        @change="handleChange"
        @preview="handlePreview"
    >
      <div v-if="fileList.length < num">
        <a-icon type="plus"/>
        <div class="ant-upload-text">
          上传
        </div>
      </div>
    </a-upload>

    <div class="file_list fix">
      <div class="file_list_item" v-for="(item,index) in fileList" :href="item.url|fileWxPath" :key="index"
           :title="item.url|fileWxPath">
        <a-icon v-if="item.url.includes('.txt')||item.url.includes('.TXT')" type="file-text"/>
        <a-icon v-else-if="item.url.includes('.pdf')||item.url.includes('.PDF')" type="file-pdf"/>
        <a-icon v-else-if="item.url.includes('.ppt')||item.url.includes('.PPT')" type="file-ppt"/>
        <a-icon v-else-if="item.url.includes('.doc')||item.url.includes('.DOC')" type="file-word"/>
        <a-icon
            v-else-if="item.url.includes('.zip')||item.url.includes('rar')||item.url.includes('.ZIP')||item.url.includes('.RAR')"
            type="file-zip"/>
        <a-icon v-else-if="item.url.includes('.xls')||item.url.includes('.XLS')" type="file-excel"/>
        <img
            v-else-if="item.url.includes('.png')||item.url.includes('.jpg')||item.url.includes('.jpeg')||item.url.includes('.gif')||item.url.includes('.PNG')||item.url.includes('.JPG')||item.url.includes('.JPEG')||item.url.includes('.GIF') ||item.url.includes('wework.qpic.cn')"
            :src="item.url|fileWxPath"
            alt="">


        <a-icon v-else-if="item.url.toLowerCase().includes('.ogm')||
                           item.url.toLowerCase().includes('.wmv')||
                           item.url.toLowerCase().includes('.mpg')||
                           item.url.toLowerCase().includes('.webm')||
                           item.url.toLowerCase().includes('.ogv')||
                           item.url.toLowerCase().includes('.mov')||
                           item.url.toLowerCase().includes('.asx')||
                           item.url.toLowerCase().includes('.mpeg')||
                           item.url.toLowerCase().includes('.mp4')||
                           item.url.toLowerCase().includes('.m4v')||
                           item.url.toLowerCase().includes('.avi')" type="video-camera"/>


        <a-icon v-else type="file-unknown"/>

        <div class="item_cover">
          <a v-if="!disabled" :download="item.url|fileWxPath" :href="item.url|fileWxPath"
             target="_blank">
            <a-icon v-if="item.url.includes('.txt')
          ||item.url.includes('.pdf')
          ||item.url.includes('.txt')
          ||item.url.includes('.ppt')
          ||item.url.includes('.doc')
          ||item.url.includes('.zip')
          ||item.url.includes('.xls')
          ||item.url.includes('.TXT')
          ||item.url.includes('.PDF')
          ||item.url.includes('.TXT')
          ||item.url.includes('.PPT')
          ||item.url.includes('.DOC')
          ||item.url.includes('.ZIP')
          ||item.url.includes('.XLS')
" type="arrow-down" title="下载"/>
          </a>
          <a :href="item.url|fileWxPath" target="_blank">
            <a-icon v-if="item.url.includes('.png')
          ||item.url.includes('.jpg')
          ||item.url.includes('.jpeg')
          ||item.url.includes('.gif')
          ||item.url.includes('.PNG')
          ||item.url.includes('.JPG')
          ||item.url.includes('.JPEG')
          ||item.url.includes('.GIF')
          ||item.url.includes('wework.qpic.cn')
" type="eye" title="查看"/>
          </a>

          <a :href="item.url|fileWxPath" target="_blank">
            <a-icon v-if="item.url.toLowerCase().includes('.ogm')||
                           item.url.toLowerCase().includes('.wmv')||
                           item.url.toLowerCase().includes('.mpg')||
                           item.url.toLowerCase().includes('.webm')||
                           item.url.toLowerCase().includes('.ogv')||
                           item.url.toLowerCase().includes('.mov')||
                           item.url.toLowerCase().includes('.asx')||
                           item.url.toLowerCase().includes('.mpeg')||
                           item.url.toLowerCase().includes('.mp4')||
                           item.url.toLowerCase().includes('.m4v')||
                           item.url.toLowerCase().includes('.avi')
" type="eye" title="查看"/>
          </a>
          <a-icon v-if="!disabled" type="delete" title="删除" @click="removeFile(index)"/>
        </div>
      </div>
    </div>


    <!--    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">-->
    <!--      <img alt="example" style="width: 100%;height: 500px;object-fit: contain" :src="previewImage"/>-->
    <!--    </a-modal>-->
    <div class="loading-container" v-show="showLoading">
      <a-spin size="large"/>
    </div>
  </div>

</template>

<script>
import api from '@/services/api'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/**
 * 表单组件
 */
export default {
  components: {},
  props: {
    field: {
      type: String,
    },
    url: {
      type: String,
    },
    value: {
      type: String,
    },
    num: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limitSize:{
      type: Number,
      default: 0
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  filters: {
    fileWxPath(data) {
      if (data.includes('http')) {
        return data;
      } else {
        return api.temp.FILE_PATH + data
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
        if (val !== this.filePath) {
          this.filePath = val;
          let arr = this.filePath ? this.filePath.split(',') : [];
          this.fileList = arr.map((v) => {
            return {
              // uid: i * -1,
              name: v,
              url: v,
              // thumbUrl: v,
            }
          })
        }
      }
    }
  },
  computed: {
    headers() {
      return {
        token: localStorage.getItem('token') || ''
      }
    }
  },
  data() {
    return {
      api,
      action: api.temp.UPLOAD_PATH,
      fileList: [],
      filePath: '',
      previewImage: '',
      previewVisible: false,
      showLoading: false
    }
  },
  methods: {
    /**
     * 删除文件
     * @param index 序号
     */
    removeFile(index) {
      this.fileList.splice(index, 1);
      let filePath = this.fileList.map(v => {
        return v.url
      }).join(',');
      this.filePath = filePath;
      this.$emit('change', filePath);
    },
    /**
     * 设置值 通用写法
     * @param val
     */
    setFormChangeData(val) {
      this.fileList = val ? val.split(',') : [];
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({file}) {
      if(this.limitSize){
        const isLt2M = file.size / 1024 / 1024 < this.limitSize;
        if (!isLt2M) {
          // throw '图片不能超过'+this.limitSize+'M'
          this.$message.error('图片不能超过'+this.limitSize+'M');
          return false
        }
      }
      if (this.fileList.length > this.num) {
        return
      }
      if (file.status === 'uploading') {
        this.showLoading = true
      } else if (file.status === 'done') {
        console.log(file)
        if (file.response.code !== 200) {
          this.$message.error(file.response.msg);
          this.showLoading = false
        } else {
          this.$message.success('上传成功');
          this.showLoading = false
          this.fileList.push(file.response.data)
          this.filePath = this.fileList.map(v => {
            return v.url
          }).join(',');
          this.$emit('change', this.filePath,file);
        }
      } else {
        this.showLoading = false
        this.$message.error('上传失败，请检查文件后重试');
      }
    },
  }
};
</script>
<style scoped lang="less">
.file_list {
  .file_list_item {
    display: block;
    width: 104px;
    height: 104px;
    border: 1px solid #e0e0e0;
    margin: 0 9px 9px 0;
    float: left;
    text-align: center;
    line-height: 102px;
    font-size: 30px;
    position: relative;
    padding: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      margin: 0;
      display: block;
    }

    .item_cover {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .5);
      z-index: 1;
      opacity: 0;
      transition: .3s all;
      color: #fff;
      font-size: 18px;

      a {
        color: #fff;
      }

      i {
        cursor: pointer;
        margin: 0 10px;
      }
    }
  }

  .file_list_item:hover {
    .item_cover {
      opacity: 1
    }
  }

}
</style>
